import { PrinterOutlined } from '@ant-design/icons'
import { Button, Empty, Input, Tag } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { withRouter } from 'react-router-dom'
import { MagnifierOutlineIcon } from '../../components/AppIcon'
import { AppTable } from '../../components/AppTable/AppTable'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import UnreadText from '../../components/UnreadText/UnreadText'
import config from '../../config'
import { DATE_FORMAT_DEFAULT } from '../../constants'
import DocumentsLayout from '../../layouts/DocumentsLayout'
import AdvanceFilterBlock from './AdvanceFilterBlock'
import { TableActionWrapper } from './ConnectedCommitteeDocumentOutgoingDocPageStyled'
import AppPageHeader from '../../components/AppPageHeader'
import utils from '../../utils'

const { Search } = Input
const { systemName } = config

const ConnectedCommitteeDocumentOutgoingDocPage = props => {
  const {
    history,
    connectedCommitteeDocumentStore,
    loadingAnimationStore,
    connectedDocumentStore,
    authenticationStore,
  } = props

  const {
    outgoingCommitteeDocumentList,
    outgoingCommitteeDocumentListTotalCount,
    outgoingCommitteeDocumentListPageIndex,
    outgoingCommitteeDocumentListPageSize,
    setFilter,
    outgoingCommitteeDocumentListFilterByKeyword,
  } = connectedCommitteeDocumentStore

  const renderBussinessDocTypeName = typeId => {
    switch (typeId) {
      case '0':
        return 'Tạo văn bản mới'
      case '1':
        return 'Thu hồi văn bản đã gửi'
      case '2':
        return 'Cập nhật văn bản đã gửi'
      case '3':
        return 'Thay thế văn bản đã gửi'
      default:
        return ''
    }
  }

  const NGAY_GUI_WIDTH = 120
  const SO_VAN_BAN_WIDTH = 150
  const TRICH_YEU_WIDTH = 450
  const TRANG_THAI_WIDTH = 100
  const LOAI_NGHIEP_VU_WIDTH = 250
  const SCROLL_WIDTH = 1000

  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
  const [disabledSearchBtn, setDisabledSearchBtn] = useState(true)
  const [reload, setReload] = useState(false)

  let [searchOptionTitle, setSearchOptionTitle] = useState('')
  const [searchOption, setSearchOption] = useState({
    bussiness_doc_type: undefined,
    status: undefined,
    title: undefined,
  })

  const [exportLoading, setExportLoading] = useState(false)
  // check hiển thị phân trang khi load dữ liệu
  const [checkPagination, setCheckPagination] = useState(true)

  const tableColumns = [
    {
      title: 'Ngày gửi',
      width: NGAY_GUI_WIDTH,
      render: record => (
        <UnreadText
          text={moment(record.sent_time).format(DATE_FORMAT_DEFAULT)}
          isUnread={checkUnread(record)}
          width={NGAY_GUI_WIDTH}
        />
      ),
    },
    {
      title: 'Số văn bản',
      width: SO_VAN_BAN_WIDTH,
      render: record => (
        <UnreadText
          text={record.code}
          isUnread={checkUnread(record)}
          width={SO_VAN_BAN_WIDTH}
        />
      ),
    },
    {
      title: 'Trích yếu',
      width: TRICH_YEU_WIDTH,
      render: record => (
        <UnreadText
          text={record.title}
          isUnread={checkUnread(record)}
          width={TRICH_YEU_WIDTH}
        />
      ),
    },
    {
      title: 'Trạng thái',
      width: TRANG_THAI_WIDTH,
      align: 'center',
      render: record => (
        <Tag color={utils.renderDocumentCommitteeTag(record.status).color}>
          {record.status !== undefined &&
            utils.renderDocumentCommitteeTag(record.status).name}
        </Tag>
      ),
    },
    {
      title: 'Loại nghiệp vụ',
      width: LOAI_NGHIEP_VU_WIDTH,
      render: record => (
        <UnreadText
          text={renderBussinessDocTypeName(record.bussiness_doc_type)}
          isUnread={checkUnread(record)}
          width={LOAI_NGHIEP_VU_WIDTH}
        />
      ),
    },
  ]

  const checkUnread = record => false

  const exportDocument = useCallback(() => {
    setExportLoading(true)

    if (!showAdvanceFilter) {
      setFilter(
        'outgoingCommitteeDocumentListFilterByKeyword',
        searchOptionTitle ? searchOptionTitle.trim() : undefined
      )
    } else {
      setFilter('outgoingCommitteeDocumentListAllPageIndex', 0)
      setFilter(
        'outgoingCommitteeDocumentListFilterByKeyword',
        searchOption.title ? searchOption.title.trim() : undefined
      )
      setFilter(
        'outgoingCommitteeDocumentListFilterByStatus',
        searchOption.status
      )
      setFilter(
        'outgoingCommitteeDocumentListFilterByBussinessDocType',
        searchOption.bussiness_doc_type
      )
    }

    const col = [
      'Ngày gửi',
      'Số văn bản',
      'Trích yếu',
      'Trạng thái',
      'Loại nghiệp vụ',
    ]

    let rows = []
    rows.push(col)
    connectedCommitteeDocumentStore
      .getOutgoingCommitteeDocumentListAll()
      .then(res => {
        if (res && res.data && res.data.data) {
          res.data.data.map(item => {
            rows.push([
              moment(item.sent_time).format(DATE_FORMAT_DEFAULT),
              item.code,
              item.title,
              utils.renderDocumentCommitteeTag(item.status).name,
              renderBussinessDocTypeName(item.bussiness_doc_type),
            ])
          })
        }
        utils.exportExcel(
          rows,
          'VBLT - VB đi - ' + moment().format('YYYY-MM-DD hmms')
        )
      })
      .finally(() => setExportLoading(false))
  }, [searchOptionTitle, searchOption, showAdvanceFilter])

  const handleSearch = values => {
    setSearchOption(values)
    const { title, status, bussiness_doc_type } = values

    /** Kiểm tra việc reload lại trang để lấy lại list vb */
    if (title || bussiness_doc_type || status) {
      setReload(true)
    } else {
      setReload(false)
    }

    setFilter('outgoingCommitteeDocumentListPageIndex', 0)
    setFilter(
      'outgoingCommitteeDocumentListFilterByKeyword',
      title ? title.trim() : undefined
    )
    setFilter('outgoingCommitteeDocumentListFilterByStatus', status)
    setFilter(
      'outgoingCommitteeDocumentListFilterByBussinessDocType',
      bussiness_doc_type
    )

    loadingAnimationStore.setTableLoading(true)
    connectedCommitteeDocumentStore
      .getOutgoingCommitteeDocumentList()
      .finally(() => loadingAnimationStore.setTableLoading(false))
    setDisabledSearchBtn(true)
  }
  const onQuickSearch = title => {
    setFilter('outgoingCommitteeDocumentListPageIndex', 0)
    setFilter(
      'outgoingCommitteeDocumentListFilterByKeyword',
      title ? title.trim() : undefined
    )

    loadingAnimationStore.setTableLoading(true)
    connectedCommitteeDocumentStore
      .getOutgoingCommitteeDocumentList()
      .finally(() => loadingAnimationStore.setTableLoading(false))
    setDisabledSearchBtn(true)
  }
  const onChangePagination = pageIndex => {
    setFilter('outgoingCommitteeDocumentListPageIndex', pageIndex - 1)
    loadingAnimationStore.setTableLoading(true)
    connectedCommitteeDocumentStore
      .getOutgoingCommitteeDocumentList()
      .finally(() => loadingAnimationStore.setTableLoading(false))
  }

  useEffect(() => {
    return () => {
      connectedCommitteeDocumentStore.clearOutgoingCommitteeDocumentList()
      connectedCommitteeDocumentStore.clearOutgoingCommitteeDocumentListFilter()
    }
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      loadingAnimationStore.showSpinner(true)
      await setCheckPagination(false)
      connectedCommitteeDocumentStore
        .getOutgoingCommitteeDocumentList()
        .finally(() => {
          loadingAnimationStore.showSpinner(false)
          setCheckPagination(true)
        })
    }
    fetchData()
  }, [])

  return (
    <DocumentsLayout
      title={
        <AppPageHeader
          title="Danh sách văn bản"
          addon={
            <>
              <Search
                allowClear
                onSearch={onQuickSearch}
                defaultValue={outgoingCommitteeDocumentListFilterByKeyword}
                placeholder={'Tìm kiếm văn bản theo trích yếu'}
                enterButton={
                  <MagnifierOutlineIcon
                    style={{ color: '#000', width: 16, height: 16 }}
                  />
                }
                className="custom-search-input fixed-width"
                onChange={e => {
                  setSearchOptionTitle(e.target.value)
                  setSearchOption(
                    Object.assign(searchOption, { title: e.target.value })
                  )
                }}
                value={searchOptionTitle}
              />
              <AdvanceFilterBlock
                handleChangeParams={handleSearch}
                queryParams={searchOption}
              />
              <Button loading={exportLoading} onClick={exportDocument}>
                <PrinterOutlined />
                In
              </Button>
              <Button
                onClick={() => {
                  connectedDocumentStore.clearDataReceiveDocument()
                  history.push(
                    '/connected-committee-document/outgoing-document/create'
                  )
                }}
                type={'primary'}>
                Tạo mới văn bản đi
              </Button>
            </>
          }
        />
      }
      selectedKey="outgoing-document"
      linkToIncomingDocument="/connected-committee-document/incoming-document"
      linkToOutgoingDocument="/connected-committee-document/outgoing-document"
      linkToConnectedCommitteeOrg="/connected-committee-document/organization">
      <Helmet>
        <title>Văn bản đi | {systemName} Liên thông lên UBQLV</title>
      </Helmet>

      <TableActionWrapper>
        <AppTable
          onRow={record => {
            return {
              onClick: () =>
                history.push(
                  `/connected-committee-document/outgoing-document/view/${record.doc_id}`
                ),
            }
          }}
          rowKey={record => record.doc_id}
          dataSource={outgoingCommitteeDocumentList}
          columns={tableColumns}
          pagination={false}
          scroll={{ x: SCROLL_WIDTH }}
          locale={{
            emptyText:
              checkPagination === true ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={'Không có dữ liệu'}
                />
              ) : (
                <div style={{ opacity: 0.1, height: '150px' }} />
              ),
          }}
          loading={loadingAnimationStore.tableLoading}
        />
        <AppTablePagination
          onChange={e => onChangePagination(e)}
          pageSize={outgoingCommitteeDocumentListPageSize}
          showSizeChanger={false}
          showLessItems
          current={outgoingCommitteeDocumentListPageIndex + 1}
          total={outgoingCommitteeDocumentListTotalCount}
          hideOnSinglePage={true}
        />
      </TableActionWrapper>
    </DocumentsLayout>
  )
}

ConnectedCommitteeDocumentOutgoingDocPage.propTypes = {}

export default withRouter(
  inject(
    'connectedCommitteeDocumentStore',
    'loadingAnimationStore',
    'authorityStore',
    'authenticationStore',
    'connectedDocumentStore'
  )(observer(ConnectedCommitteeDocumentOutgoingDocPage))
)
